import { Col, FormInstance, List, Row, Spin } from 'antd';
import { Container, Section, SectionBlackTitle, SectionTitle } from '../style';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  fetchTemplateCauses,
  fetchTemplateRoutines,
  selectDraftTemplate,
  selectIsFetchingTemplateRoutines,
  selectRoutines,
  selectTemplateCurrentCauses,
} from '../../../../slices/templates';
import { useAppDispatch } from '../../../../store';
import RoutineForm from '../../../../components/routineForm';
import RoutineCard from '../../../../components/routineCard';

const AddRoutine = ({ form }: { form: FormInstance }) => {
  const dispatch = useAppDispatch();

  const template = useSelector(selectDraftTemplate);
  const causes = useSelector(selectTemplateCurrentCauses);
  const routines = useSelector(selectRoutines);
  const isFetchingTemplateRoutines = useSelector(
    selectIsFetchingTemplateRoutines
  );

  useEffect(() => {
    dispatch(fetchTemplateRoutines({ templateId: template?.templateID || '' }));
  }, []);

  useEffect(() => {
    if (template?.templateID && !causes.length) {
      dispatch(fetchTemplateCauses({ templateId: template?.templateID || '' }));
    }
  }, [template?.templateID]);

  return (
    <Spin spinning={isFetchingTemplateRoutines}>
      <Container>
        <SectionTitle>Add New Routine (Optional)</SectionTitle>
        <Row gutter={16}>
          <Col span={routines.length ? 18 : 24} flex={1}>
            <RoutineForm form={form} />
          </Col>
          {!!routines.length && (
            <Col span={8}>
              <Section style={{ height: '100%' }}>
                <SectionBlackTitle>
                  Routines ({routines.length})
                </SectionBlackTitle>
                <List>
                  {routines.map((s) => (
                    <List.Item key={s?.routineID}>
                      <RoutineCard routine={s} />
                    </List.Item>
                  ))}
                </List>
              </Section>
            </Col>
          )}
        </Row>
      </Container>
    </Spin>
  );
};

export default AddRoutine;
